import useModal from "../modals";
import {DivButton} from "./button";

function ViewableImage({ viewable, preview, src, alt, post, title, author, community, ...props }) {
    const modal = useModal();

    const handleImageLoad = (e) => {
        const img = e.target;
        const originalWidth = img.style.width;

        // reduce width by 1px to trigger re-render
        img.style.width = `${img.offsetWidth - 1}px`;

        // restore the original width after a brief moment
        setTimeout(() => {
            img.style.width = originalWidth || '';
        }, 0);
    };

    const image = <img onLoad={handleImageLoad} loading="eager" src={preview} {...props} />;
    return viewable ? (
        <DivButton
            onClick={(event) => {
                event.stopPropagation();
                modal.open('ImageView', {src, title, author, community, alt, post});
            }}
        >
            {image}
        </DivButton>
    ) : image;
}

export default ViewableImage;
